const FALLBACK_LOCALE = 'en'
const EN_LOCALES = ['en', 'en-au', 'en-ca', 'en-gb', 'en-ie', 'en-il', 'en-nz', 'en-us']
const ES_LOCALES = ['es', 'es-do', 'es-us', 'es-ar', 'es-co', 'es-es', 'es-cl']
const IT_LOCALES = ['it', 'it-ch', 'it-it', 'it-do', 'it-ar', 'it-co', 'it-es', 'it-cl', 'it-us']
const DE_LOCALES = ['de', 'de-ch', 'de-at', 'de-de', 'de-do', 'de-ar', 'de-co', 'de-es', 'de-cl']
const FR_LOCALES = [
  'fr',
  'fr-ch',
  'fr-ca',
  'fr-fr',
  'fr-do',
  'fr-ar',
  'fr-co',
  'fr-es',
  'fr-cl',
  'fr-ng',
]
const FALLBACK_LOCALES = ['nl', 'nl-be', 'sv', 'el', 'eo', 'pl', 'ru', 'tr']

const createLocaleMap = (locales: string[], value: string) =>
  locales.reduce((acc, locale) => ({ ...acc, [locale]: value }), {})

const LOCALE_IN_DATO_FORMAT = {
  pt: 'pt',
  'pt-br': 'pt_BR',
  'pt-pt': 'pt',
  'es-mx': 'es_MX',
  ca: 'ca',
  ...createLocaleMap(EN_LOCALES, FALLBACK_LOCALE),
  ...createLocaleMap(IT_LOCALES, 'it'),
  ...createLocaleMap(DE_LOCALES, 'de'),
  ...createLocaleMap(ES_LOCALES, 'es'),
  ...createLocaleMap(FR_LOCALES, 'fr'),
  ...createLocaleMap(FALLBACK_LOCALES, FALLBACK_LOCALE),
} as const

type ValidLanguage = keyof typeof LOCALE_IN_DATO_FORMAT

const isValidLanguage = (locale: string): locale is ValidLanguage => {
  return locale in LOCALE_IN_DATO_FORMAT
}

export const getDatoLocale = (locale: string): string => {
  if (isValidLanguage(locale)) {
    return LOCALE_IN_DATO_FORMAT[locale]
  }
  return FALLBACK_LOCALE
}
